import { Components, Theme } from '@mui/material/styles';
import { fontWeights } from './fontWeights';

/**
 * Overrides compartilhados de tabela, usados por lightTheme e darkTheme.
 * Referência visual: src/views/AuditLogs/index.tsx (padrão oficial do sistema).
 */
export const tableComponents: Components<Omit<Theme, 'components'>> = {
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
        // Células em uma linha só: o TableContainer rola na horizontal quando falta espaço.
        // Colunas de texto livre que precisem quebrar devem sobrescrever com `whiteSpace: "normal"`.
        whiteSpace: 'nowrap',
      }),
      head: {
        fontWeight: fontWeights.semiBold,
      },
    },
  },
  MuiTablePagination: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
      }),
      selectLabel: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
      }),
      displayedRows: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
      }),
    },
  },
};
